import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import Align from "rc-align";
import Animate from "rc-animate";
import PopupInner from "./PopupInner";
import LazyRenderBox from "./LazyRenderBox";
import { saveRef } from "./utils";

class Popup extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    style: PropTypes.object,
    getClassNameFromAlign: PropTypes.func,
    onAlign: PropTypes.func,
    getRootDomNode: PropTypes.func,
    onMouseEnter: PropTypes.func,
    align: PropTypes.any,
    destroyPopupOnHide: PropTypes.bool,
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    onMouseLeave: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.savePopupRef = saveRef.bind(this, "popupInstance");
    this.saveAlignRef = saveRef.bind(this, "alignInstance");
  }

  componentDidMount() {
    this.rootNode = this.getPopupDomNode();
  }

  onAlign = (popupDomNode, align) => {
    const props = this.props;
    const currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (this.currentAlignClassName !== currentAlignClassName) {
      this.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = this.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  getPopupDomNode() {
    return ReactDOM.findDOMNode(this.popupInstance);
  }

  getTarget = () => {
    return this.props.getRootDomNode();
  };

  getMaskTransitionName() {
    const props = this.props;
    let transitionName = props.maskTransitionName;
    const animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = `${props.prefixCls}-${animation}`;
    }
    return transitionName;
  }

  getTransitionName() {
    const props = this.props;
    let transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = `${props.prefixCls}-${props.animation}`;
    }
    return transitionName;
  }

  getClassName(currentAlignClassName) {
    return `${this.props.prefixCls} ${this.props.className} ${currentAlignClassName}`;
  }

  getPopupElement() {
    const { savePopupRef, props } = this;
    const {
      align,
      style,
      visible,
      prefixCls,
      destroyPopupOnHide,
      ecId
    } = props;
    const className = this.getClassName(
      this.currentAlignClassName || props.getClassNameFromAlign(align)
    );
    const hiddenClassName = `${prefixCls}-hidden`;
    if (!visible) {
      this.currentAlignClassName = null;
    }
    const newStyle = {
      ...style,
      ...this.getZIndexStyle()
    };
    const popupInnerProps = {
      className,
      prefixCls,
      ref: savePopupRef,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return (
        <Animate
          component=""
          exclusive
          transitionAppear
          transitionName={this.getTransitionName()}
          ecId={`${ecId}_Animate@93e6ql`}
        >
          {visible ? (
            <Align
              target={this.getTarget}
              key="popup"
              ref={this.saveAlignRef}
              monitorWindowResize
              align={align}
              onAlign={this.onAlign}
              ecId={`${ecId}_Align@0k6rae`}
            >
              <PopupInner
                visible
                {...popupInnerProps}
                ecId={`${ecId}_PopupInner@uh3doz`}
              >
                {props.children}
              </PopupInner>
            </Align>
          ) : null}
        </Animate>
      );
    }
    return (
      <Animate
        ecId={`${ecId}_Animate@2y3fw7`}
        component=""
        exclusive
        transitionAppear
        transitionName={this.getTransitionName()}
        showProp="xVisible"
      >
        <Align
          ecId={`${ecId}_Align@rbujkp`}
          target={this.getTarget}
          key="popup"
          ref={this.saveAlignRef}
          monitorWindowResize
          xVisible={visible}
          childrenProps={{ visible: "xVisible" }}
          disabled={!visible}
          align={align}
          onAlign={this.onAlign}
        >
          <PopupInner
            hiddenClassName={hiddenClassName}
            {...popupInnerProps}
            ecId={`${ecId}_PopupInner@8utwji`}
          >
            {props.children}
          </PopupInner>
        </Align>
      </Animate>
    );
  }

  getZIndexStyle() {
    const style = {};
    const props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  }

  getMaskElement() {
    const props = this.props;
    let maskElement;
    if (props.mask) {
      const maskTransition = this.getMaskTransitionName();
      maskElement = (
        <LazyRenderBox
          ecId={`${props.ecId}_LazyRenderBox@fqcq8j`}
          style={this.getZIndexStyle()}
          key="mask"
          className={`${props.prefixCls}-mask`}
          hiddenClassName={`${props.prefixCls}-mask-hidden`}
          visible={props.visible}
        />
      );
      if (maskTransition) {
        maskElement = (
          <Animate
            ecId={`${props.ecId}_Animate@zo4se4`}
            key="mask"
            showProp="visible"
            transitionAppear
            component=""
            transitionName={maskTransition}
          >
            {maskElement}
          </Animate>
        );
      }
    }
    return maskElement;
  }

  render() {
    return (
      <div className={this.props.triggerMaskClassName || ""}>
        {this.getMaskElement()}
        {this.getPopupElement()}
      </div>
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./_rc-trigger-1.11.4/src/Popup.js